import React, {useState} from 'react';
import Modal from '@homeaway/react-modal';

const WithModal = ({id, modalContent, children}) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleOpen = () => {
        setIsOpen(true);
    };
    const handleClose = () => {
        setIsOpen(false);
    };
    return (
        <React.Fragment>
            {children(handleOpen)}
            <Modal id={id} isOpen={isOpen} onClose={handleClose}>
                {modalContent}
            </Modal>
        </React.Fragment>
    );
};

export default WithModal;
